import React, { Component } from "react";
import { Container, Row, Col, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import AssignTestModal from "./AssignTestModal";
import "./_admissionForms.scss";
import { triggerSms } from "../../utils/smsHelper";
import { triggerEmail } from "../../utils/emailHelper";
import SendSMSModal from "./SendSMSModal";
import SendEmailModal from "./SendEmailModal";
import SendWhatsAppModal from "./SendWhatsAppModal";

// ── GraphQL Queries ───────────────────────────────────────
const GET_ENQUIRY_SUBMISSIONS = gql`
  query ($form_id: Int!) {
    getEnquirySubmissions(form_id: $form_id) {
      id
      enquiry_form_id
      student_name
      student_mobile
      student_email
      gender
      dob
      institute_id
      branch_id
      estatus
      extra_details
    }
  }
`;

const GET_ASSIGNED_TEST = gql`
  query ($enquiry_form_master_id: Int!) {
    getAssignedTest(enquiry_form_master_id: $enquiry_form_master_id) {
      id
      admission_test_id
      username
      password
      estatus
    }
  }
`;

const GET_ADMISSION_TEST_SESSION = gql`
  query ($enquiry_form_master_id: Int!, $admission_test_id: Int!) {
    getAdmissionTestSession(
      enquiry_form_master_id: $enquiry_form_master_id
      admission_test_id: $admission_test_id
    ) {
      id
      is_completed
      total_marks_gained
      total_marks
      
      # ── TODO: Uncomment when you want to show detailed performance info ──
      # correct
      # wrong
      # not_answer
    }
  }
`;

const ASSIGN_ADMISSION_TEST_AUTO = gql`
  mutation ($enquiry_form_master_id: Int!, $institute_id: Int!, $branch_id: String!, $inserted_by: Int) {
    assignAdmissionTestAuto(
      enquiry_form_master_id: $enquiry_form_master_id,
      institute_id: $institute_id,
      branch_id: $branch_id,
      inserted_by: $inserted_by
    ) {
      id
      username
      password
    }
  }
`;

const MARK_AS_ADMITTED = gql`
  mutation ($enquiry_form_master_id: Int!, $admission_test_id: Int!) {
    markAsAdmitted(
      enquiry_form_master_id: $enquiry_form_master_id,
      admission_test_id: $admission_test_id
    )
  }
`;

class RegisteredStudentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      students: [],
      filteredStudents: [],
      loader: true,
      error: "",
      searchQuery: "",
      selectedBranches: [],
      selectedStatus: [],

      // Assign test modal
      showAssignModal: false,
      selectedStudent: null,

      // Student detail modal
      showDetailModal: false,
      detailStudent: null,

      // SMS modal
      showSMSModal: false,
      smsStudent: null,

      // Email modal
      showEmailModal: false,
      emailStudent: null,
      
      // WhatsApp modal
      showWAModal: false,
      waStudent: null,
    };
  }

  componentDidMount() {
    this.initBranches();
    this.fetchStudents();
  }

  componentDidUpdate(prevProps) {
    const branches = this.props.globals && this.props.globals.globalBranches;
    const prevBranches = prevProps.globals && prevProps.globals.globalBranches;
    if (
      branches &&
      branches !== prevBranches &&
      this.state.selectedBranches.length === 0
    ) {
      this.initBranches();
    }
  }

  initBranches = () => {
    const branches = this.props.globals && this.props.globals.globalBranches;
    if (branches && branches.length > 0) {
      let authorizedIds = [];
      try {
        const cookie = Cookies.get("branch_id");
        const parsed = cookie ? JSON.parse(cookie) : [];
        authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        try {
          const cookie = Cookies.get("branch_id");
          authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
        } catch (err) { console.error(err); }
      }
      authorizedIds = authorizedIds.map(String);

      const selected = branches
        .filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)))
        .map((b) => ({
          label: b.branch_name,
          value: b.id,
        }));
      this.setState({ selectedBranches: selected }, this.applyFilters);
    }
  };

  fetchStudents = async () => {
    const { formId } = this.props;

    this.setState({ loader: true, error: "" });

    try {
      const result = await this.props.client.query({
        query: GET_ENQUIRY_SUBMISSIONS,
        variables: {
          form_id: parseInt(formId),
        },
        fetchPolicy: "network-only",
      });

      const submissions = result.data.getEnquirySubmissions || [];

      // Fetch test assignment + session status for each student
      const studentsWithTestStatus = await Promise.all(
        submissions.map(async (student) => {
          try {
            // Step 1: Check if a test has been assigned
            const assignedResult = await this.props.client.query({
              query: GET_ASSIGNED_TEST,
              variables: { enquiry_form_master_id: parseInt(student.id) },
              fetchPolicy: "network-only",
            });
            const assigned = assignedResult.data.getAssignedTest;

            if (!assigned) {
              return {
                ...student,
                test_status: "",
                test_score: null,
                total_marks: null,
              };
            }

            // Step 2: If assigned, check if test was completed
            const sessionResult = await this.props.client.query({
              query: GET_ADMISSION_TEST_SESSION,
              variables: {
                enquiry_form_master_id: parseInt(student.id),
                admission_test_id: parseInt(assigned.admission_test_id),
              },
              fetchPolicy: "network-only",
            });
            const session = sessionResult.data.getAdmissionTestSession;

            if (session && session.is_completed === 1) {
              return {
                ...student,
                test_status: "completed",
                test_score: session.total_marks_gained,
                total_marks: session.total_marks,
                admission_test_id: assigned.admission_test_id,
                admitted_status: assigned.estatus,
                username: assigned.username,
                password: assigned.password,
              };
            }

            return {
              ...student,
              test_status: "assigned",
              test_score: null,
              total_marks: null,
              admission_test_id: assigned.admission_test_id,
              admitted_status: assigned.estatus,
              username: assigned.username,
              password: assigned.password,
            };
          } catch (e) {
            console.log(
              "Could not fetch test status for",
              student.student_name,
              e,
            );
            return {
              ...student,
              test_status: "",
              test_score: null,
              total_marks: null,
            };
          }
        }),
      );

      this.setState({
        students: studentsWithTestStatus,
        loader: false,
      }, this.applyFilters);
    } catch (err) {
      console.error("Error fetching submissions:", err);
      this.setState({
        loader: false,
        error: "Failed to load registered students. Please try again.",
      });
    }
  };

  applyFilters = () => {
    const { students, searchQuery, selectedBranches, selectedStatus } = this.state;
    const query = searchQuery.toLowerCase().trim();
    const branchIds = selectedBranches.map((b) => b.value);
    const statusValues = selectedStatus.map((s) => s.value);

    const filtered = students.filter((s) => {
      const matchesSearch =
        !query ||
        (s.student_name || "").toLowerCase().includes(query) ||
        (s.student_mobile || "").toLowerCase().includes(query) ||
        (s.student_email || "").toLowerCase().includes(query);

      // Extract branch IDs to string array for robust comparison
      const selectedBranchIds = branchIds.map(id => String(id));
      const studentBranchId = s.branch_id ? String(s.branch_id) : "";
      const matchesBranch = branchIds.length === 0 || selectedBranchIds.includes(studentBranchId);

      // Exam Status Filter
      const studentStatus = (s.test_status || "").toLowerCase();
      const matchesStatus = statusValues.length === 0 || statusValues.includes(studentStatus);

      return matchesSearch && matchesBranch && matchesStatus;
    });

    this.setState({ filteredStudents: filtered });
  };

  handleSearch = (e) => {
    this.setState({ searchQuery: e.target.value }, this.applyFilters);
  };

  handleBranchChange = (selected) => {
    this.setState({ selectedBranches: selected }, this.applyFilters);
  };

  handleStatusChange = (selected) => {
    this.setState({ selectedStatus: selected }, this.applyFilters);
  };


  openAssignModal = (student) => {
    this.setState({
      showAssignModal: true,
      selectedStudent: {
        id: student.id,
        student_name: student.student_name,
        student_mobile: student.student_mobile,
        branch_id: student.branch_id,
      },
    });
  };

  closeAssignModal = () => {
    this.setState({ showAssignModal: false, selectedStudent: null });
    // Refresh data after closing
    this.fetchStudents();
  };

  openDetailModal = (student) => {
    this.setState({ showDetailModal: true, detailStudent: student });
  };

  closeDetailModal = () => {
    this.setState({ showDetailModal: false, detailStudent: null });
  };

  openSMSModal = (student) => {
    this.setState({ showSMSModal: true, smsStudent: student });
  };

  closeSMSModal = () => {
    this.setState({ showSMSModal: false, smsStudent: null });
  };

  openEmailModal = (student) => {
    this.setState({ showEmailModal: true, emailStudent: student });
  };

  closeEmailModal = () => {
    this.setState({ showEmailModal: false, emailStudent: null });
  };

  openWAModal = (student) => {
    this.setState({ showWAModal: true, waStudent: student });
  };

  closeWAModal = () => {
    this.setState({ showWAModal: false, waStudent: null });
  };



  handleMarkAdmitted = async (student) => {
    if (!student.admission_test_id) {
      alert("No test assignment found for this student.");
      return;
    }

    if (!window.confirm(`Are you sure you want to mark ${student.student_name} as Admitted?`)) {
      return;
    }

    this.setState({ loader: true });
    try {
      await this.props.client.mutate({
        mutation: MARK_AS_ADMITTED,
        variables: {
          enquiry_form_master_id: parseInt(student.id),
          admission_test_id: parseInt(student.admission_test_id),
        },
      });
      // Refresh students to reflect changes
      await this.fetchStudents();

      // Automatically trigger SMS notification for admission
      triggerSms(this.props.client, {
        student,
        type: 'ADMITTED'
      });

      // Automatically trigger Email confirmation
      triggerEmail(this.props.client, {
        student,
        type: 'ADMISSION_CONFIRMED'
      });

      alert(`${student.student_name} has been marked as Admitted.`);

    } catch (err) {
      console.error("Error marking as admitted:", err);
      this.setState({ loader: false });
      alert("Failed to mark student as admitted: " + err.message.replace("GraphQL error: ", ""));
    }
  };

  getStatusBadge = (student) => {
    const status = (student.test_status || "").toLowerCase();
    const admittedStatus = student.admitted_status;

    if (admittedStatus === 4) {
      return (
        <span className="af-status-badge af-status-admitted">
          <i className="fas fa-graduation-cap" /> Admitted
        </span>
      );
    }

    if (status === "completed") {
      return (
        <span className="af-status-badge af-status-completed">
          <i className="fas fa-check-circle" /> Completed
        </span>
      );
    }
    if (status === "assigned") {
      return (
        <span className="af-status-badge af-status-assigned">
          <i className="fas fa-clock" /> Assigned
        </span>
      );
    }
    return (
      <span className="af-status-badge af-status-not-assigned">
        <i className="fas fa-minus-circle" /> Not Assigned
      </span>
    );
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "—";
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  render() {
    const {
      filteredStudents,
      loader,
      error,
      searchQuery,
      selectedBranches,
      showAssignModal,
      selectedStudent,
      showDetailModal,
      detailStudent,
      students,
    } = this.state;

    const { stateData, globals } = this.props;
    const formName = stateData?.form_name || "Admission Form";

    let authorizedIds = [];
    try {
      const cookie = Cookies.get("branch_id");
      const parsed = cookie ? JSON.parse(cookie) : [];
      authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      try {
        const cookie = Cookies.get("branch_id");
        authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
      } catch (err) { console.error(err); }
    }
    authorizedIds = authorizedIds.map(String);

    const branchOptions = (globals?.globalBranches || [])
      .filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)))
      .map(b => ({
        label: b.branch_name,
        value: b.id
      }));

    const statusOptions = [
      { label: "Completed", value: "completed" },
      { label: "Assigned", value: "assigned" },
      { label: "Not Assigned", value: "" },
    ];

    return (
      <Container fluid className="px-4 pb-5">
        {/* ── Breadcrumb Navigation ── */}
        <ul className="af-breadcrumb mt-4">
          <li className="af-bc-item">
            <a href="#/admissions-dashboard" onClick={(e) => { e.preventDefault(); this.props.history.push("/admissions-dashboard"); }}>
              Admissions
            </a>
          </li>
          <li className="af-bc-item">
            <a href="#/admission-forms" onClick={(e) => { e.preventDefault(); this.props.history.push("/admission-forms"); }}>
              Forms
            </a>
          </li>
          <li className="af-bc-item">
            <a href={`#/admission-forms/fill/${this.state.formId}`} onClick={(e) => { e.preventDefault(); this.props.history.push(`/admission-forms/fill/${this.state.formId}`, this.props.location.state); }}>
              {formName}
            </a>
          </li>
          <li className="af-bc-item active">Registrations</li>
        </ul>

        {/* ── Page Header ── */}
        <div className="af-admin-header mt-4 mb-4 pb-3 border-bottom d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center" style={{ gap: "20px" }}>
          <div>
            <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
              <i className="fas fa-users-cog mr-2 text-primary opacity-75" />
              {formName} <span className="af-title-suffix">Registrations</span>
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
              View and manage registered students and their test statuses.
            </p>
          </div>

          {/* KPI Cards — Dashboard Style */}
          <div className="af-kpi-metrics-row d-flex align-items-center" style={{ gap: "12px" }}>
            <div className="af-kpi-card shadow-sm">
              <div className="af-kpi-val">{students.length}</div>
              <div className="af-kpi-lbl">Total Students</div>
            </div>
            <div className="af-kpi-card shadow-sm border-success-subtle">
              <div className="af-kpi-val text-success">
                {students.filter(s => (s.test_status || "").toLowerCase() === "completed").length}
              </div>
              <div className="af-kpi-lbl">Tests Completed</div>
            </div>
            <div className="af-kpi-card shadow-sm border-warning-subtle">
              <div className="af-kpi-val text-warning">
                {students.filter(s => (s.test_status || "").toLowerCase() !== "completed").length}
              </div>
              <div className="af-kpi-lbl">Pending Submissions</div>
            </div>
            <div className="af-kpi-card shadow-sm border-primary-subtle">
              <div className="af-kpi-val text-primary">
                {students.filter(s => s.admitted_status === 4).length}
              </div>
              <div className="af-kpi-lbl">Admitted</div>
            </div>
          </div>
        </div>

        {/* ── Filter Bar ── */}
        <div className="af-results-filter-bar mb-4">
          <Row className="justify-content-center align-items-center" style={{ rowGap: "16px" }}>
            <Col xl={3} lg={4} md={6}>
              <div className="af-search-input-wrap">
                <i className="fas fa-search af-search-icon" />
                <input
                  type="text"
                  className="af-search-input"
                  placeholder="Search student..."
                  value={searchQuery}
                  onChange={this.handleSearch}
                />
                {searchQuery && (
                  <button className="af-search-clear" onClick={() => this.setState({ searchQuery: "" }, this.applyFilters)}>
                    <i className="fas fa-times" />
                  </button>
                )}
              </div>
            </Col>
            <Col xl={3} lg={4} md={6}>
              <div style={{ width: branchOptions.length > 1 ? "100%" : "auto" }}>
                {branchOptions.length > 1 ? (
                  <div className="af-dash-multiselect">
                    <MultiSelect
                      options={branchOptions}
                      value={selectedBranches}
                      onChange={this.handleBranchChange}
                      labelledBy="Select Branches"
                      overrideStrings={{ selectSomeItems: "Filter by Branches" }}
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center py-2 px-3 bg-light rounded border" style={{ gap: "8px", fontSize: "14px", color: "#475569", height: "40px" }}>
                    <i className="fas fa-building text-primary opacity-75" />
                    <strong>Branch:</strong> {branchOptions[0] ? branchOptions[0].label : "Default Branch"}
                  </div>
                )}
              </div>
            </Col>
            <Col xl={3} lg={4} md={6}>
              <div className="af-dash-multiselect">
                <MultiSelect
                  options={statusOptions}
                  value={this.state.selectedStatus}
                  onChange={this.handleStatusChange}
                  labelledBy="Exam Status"
                  overrideStrings={{ selectSomeItems: "Filter by Status" }}
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* ── Content Area ── */}
        <div className="af-content-card shadow-sm">
          {loader ? (
            <div className="table-responsive">
              <table className="table af-skeleton-table mb-0">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}><span className="af-skeleton-box w-100"></span></th>
                    <th><span className="af-skeleton-box"></span></th>
                    <th><span className="af-skeleton-box"></span></th>
                    <th><span className="af-skeleton-box"></span></th>
                    <th><span className="af-skeleton-box mx-auto"></span></th>
                    <th className="text-center"><span className="af-skeleton-box w-75 mx-auto"></span></th>
                    <th className="text-center"><span className="af-skeleton-box w-75 mx-auto"></span></th>
                    <th className="text-right" style={{ paddingRight: "24px" }}><span className="af-skeleton-box w-50 ml-auto"></span></th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5].map((i) => (
                    <tr key={i}>
                      <td><span className="af-skeleton-box af-sk-sub w-100"></span></td>
                      <td>
                        <span className="af-skeleton-box af-sk-title"></span>
                        <span className="af-skeleton-box af-sk-sub"></span>
                      </td>
                      <td><span className="af-skeleton-box af-sk-title"></span></td>
                      <td>
                        <span className="af-skeleton-box af-sk-title"></span>
                        <span className="af-skeleton-box af-sk-sub"></span>
                      </td>
                      <td><span className="af-skeleton-box af-sk-title"></span></td>
                      <td className="text-center"><span className="af-skeleton-box af-sk-badge mx-auto"></span></td>
                      <td className="text-center"><span className="af-skeleton-box af-sk-title mx-auto"></span></td>
                      <td className="text-right">
                        <span className="af-skeleton-box af-sk-action"></span>
                        <span className="af-skeleton-box af-sk-action"></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : error ? (
            <div className="af-error-container py-5">
              <i className="fas fa-exclamation-circle text-danger mb-3" style={{ fontSize: "32px" }} />
              <h5>Connection Error</h5>
              <p className="text-muted">{error}</p>
              <button className="btn btn-outline-primary btn-sm mt-2" onClick={this.fetchStudents}>Try Again</button>
            </div>
          ) : filteredStudents.length === 0 ? (
            <div className="af-empty-container py-5 text-center">
              <div className="af-empty-icon-wrap mb-3">
                <i className="fas fa-user-friends text-muted opacity-25" style={{ fontSize: "56px" }} />
              </div>
              <h5>No Students Found</h5>
              <p className="text-muted mx-auto" style={{ maxWidth: "400px" }}>
                {searchQuery || selectedBranches.length < branchOptions.length
                  ? "We couldn't find any students matching your current filters. Try adjusting your search term or branch selection."
                  : "No students have registered using this form yet."}
              </p>
              {(searchQuery || selectedBranches.length < branchOptions.length) && (
                <button className="btn btn-link text-primary mt-2" onClick={() => this.setState({ searchQuery: "", selectedBranches: branchOptions }, this.applyFilters)}>
                  Clear all filters
                </button>
              )}
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table af-modern-table mb-0">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>#</th>
                    <th>Student Name</th>
                    <th>Mobile</th>
                    <th>Details</th>
                    <th>Date Registered</th>
                    <th className="text-center">Exam Status</th>
                    <th className="text-center">Result</th>
                    <th className="text-right" style={{ paddingRight: "24px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredStudents.map((student, index) => (
                    <tr key={student.id || index}>
                      <td className="text-muted" style={{ fontSize: "12px" }}>{(index + 1).toString().padStart(2, '0')}</td>
                      <td>
                        <div className="d-flex flex-column">
                          <span className="af-student-primary-name" onClick={() => this.openDetailModal(student)}>
                            {student.student_name || "—"}
                          </span>
                          <span className="af-student-sub-text">ID: #{student.id}</span>
                        </div>
                      </td>
                      <td>
                        <a
                          href={`tel:${student.student_mobile}`}
                          className="af-phone-wrap"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          title="Click to call"
                        >
                          <i className="fas fa-phone-alt mr-2 opacity-40" />
                          {student.student_mobile || "—"}
                        </a>
                      </td>
                      <td>
                        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
                          <span className="text-truncate" style={{ maxWidth: "160px" }} title={student.student_email}>
                            {student.student_email || "—"}
                          </span>
                          <span className="text-muted" style={{ fontSize: "11px" }}>{student.gender || "—"} | {this.formatDate(student.dob)}</span>
                        </div>
                      </td>
                      <td className="text-muted">{this.formatDate(student.created_at || new Date())}</td>
                      <td className="text-center">
                        {this.getStatusBadge(student)}
                      </td>
                      <td className="text-center">
                        {(student.test_status || "").toLowerCase() === "completed" ? (
                          <div className="af-score-pill">
                            <span className="af-score-val">{student.test_score ?? "—"}</span>
                            <span className="af-score-max">/ {student.total_marks || "300"}</span>
                          </div>
                        ) : (
                          <span className="text-muted opacity-40">—</span>
                        )}
                      </td>
                      <td className="text-right">
                        <div className="af-actions-flex justify-content-end">
                          {(student.test_status || "").toLowerCase() !== "completed" && (
                            <button
                              className="af-action-pill-btn"
                              onClick={() => this.openAssignModal(student)}
                            >
                              Assign
                            </button>
                          )}
                          {(student.test_status || "").toLowerCase() === "completed" && student.admitted_status !== 4 && (
                            <button
                              className="af-action-pill-btn admit-btn"
                              onClick={() => this.handleMarkAdmitted(student)}
                            >
                              <i className="fas fa-user-check mr-1" /> Admit
                            </button>
                          )}

                          <OverlayTrigger placement="top" overlay={<Tooltip id={`view-t-${student.id}`}>View Details</Tooltip>}>
                            <button
                              className="af-action-icon-btn view-btn"
                              onClick={() => this.openDetailModal(student)}
                            >
                              <i className="fas fa-eye" />
                            </button>
                          </OverlayTrigger>

                          {student.student_email && (
                            <OverlayTrigger placement="top" overlay={<Tooltip id={`email-t-${student.id}`}>Send Email</Tooltip>}>
                              <button
                                className="af-action-icon-btn email-btn"
                                onClick={() => this.openEmailModal(student)}
                              >
                                <i className="fas fa-envelope" />
                              </button>
                            </OverlayTrigger>
                          )}
                          {student.student_mobile && (
                            <OverlayTrigger placement="top" overlay={<Tooltip id={`sms-t-${student.id}`}>Send SMS</Tooltip>}>
                              <button
                                className="af-action-icon-btn sms-btn"
                                onClick={() => this.openSMSModal(student)}
                              >
                                <i className="fas fa-comment-dots" />
                              </button>
                            </OverlayTrigger>
                          )}
                          {student.student_mobile && (
                            <OverlayTrigger placement="top" overlay={<Tooltip id={`wa-t-${student.id}`}>WhatsApp</Tooltip>}>
                              <button
                                className="af-action-icon-btn wa-btn"
                                onClick={() => this.openWAModal(student)}
                              >
                                <i className="fab fa-whatsapp" />
                              </button>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ── Modals ── */}
        <AssignTestModal
          show={showAssignModal}
          onHide={this.closeAssignModal}
          student={selectedStudent}
        />

        <SendSMSModal
          show={this.state.showSMSModal}
          onHide={this.closeSMSModal}
          student={this.state.smsStudent}
        />

        <SendEmailModal
          show={this.state.showEmailModal}
          onHide={this.closeEmailModal}
          student={this.state.emailStudent}
        />

        <SendWhatsAppModal
          show={this.state.showWAModal}
          onHide={this.closeWAModal}
          student={this.state.waStudent}
        />

        <Modal show={showDetailModal} onHide={this.closeDetailModal} centered size="md" className="af-student-detail-modal">
          <div className="af-modal-glass-header">
            <h5 className="m-0"><i className="fas fa-id-card mr-2" /> Student Information</h5>
            <button className="close-btn" onClick={this.closeDetailModal}>&times;</button>
          </div>
          <Modal.Body className="p-4">
            {detailStudent && (
              <div className="af-detail-list">
                <div className="af-detail-item">
                  <label>Full Name</label>
                  <span>{detailStudent.student_name || "—"}</span>
                </div>
                <div className="af-detail-item">
                  <label>Contact Details</label>
                  <span>{detailStudent.student_mobile || "—"} <br /> <small className="text-muted">{detailStudent.student_email}</small></span>
                </div>
                <Row>
                  <Col>
                    <div className="af-detail-item">
                      <label>Gender</label>
                      <span>{detailStudent.gender || "—"}</span>
                    </div>
                  </Col>
                  <Col>
                    <div className="af-detail-item">
                      <label>Date of Birth</label>
                      <span>{this.formatDate(detailStudent.dob)}</span>
                    </div>
                  </Col>
                </Row>
                <hr className="my-3 opacity-10" />
                <div className="af-detail-item">
                  <label>Admission Test</label>
                  <div className="mt-1">{this.getStatusBadge(detailStudent)}</div>
                </div>

                {/* Exam Credentials (if assigned/completed) */}
                {detailStudent.username && (
                  <div className="af-detail-item mt-3">
                    <label>Exam Credentials</label>
                    <div className="af-cred-card mt-2 shadow-sm border-light">
                      <div className="af-cred-item">
                        <span className="af-cred-label">Username</span>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="af-cred-value">{detailStudent.username}</span>
                          <button
                            className="af-mini-icon-btn"
                            onClick={() => {
                              navigator.clipboard.writeText(detailStudent.username);
                              alert('Username copied!');
                            }}
                            title="Copy Username"
                          >
                            <i className="far fa-copy"></i>
                          </button>
                        </div>
                      </div>
                      <div className="af-cred-item">
                        <span className="af-cred-label">Password</span>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="af-cred-value">{detailStudent.password}</span>
                          <button
                            className="af-mini-icon-btn"
                            onClick={() => {
                              navigator.clipboard.writeText(detailStudent.password);
                              alert('Password copied!');
                            }}
                            title="Copy Password"
                          >
                            <i className="far fa-copy"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {(detailStudent.test_status || "").toLowerCase() === "completed" && (
                  <div className="af-detail-item mt-3 p-3 bg-light rounded border border-success-subtle">
                    <label className="text-success">Performance Score</label>
                    <h3 className="m-0 text-success">{detailStudent.test_score ?? "—"} <small className="text-muted">/ {detailStudent.total_marks || 300}</small></h3>
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0 bg-light p-3">
            <button className="btn btn-secondary px-4 h-9" onClick={this.closeDetailModal}>Close</button>
            {detailStudent && (detailStudent.test_status || "").toLowerCase() !== "completed" && (
              <button className="btn btn-primary px-4 h-9" onClick={() => { this.closeDetailModal(); this.openAssignModal(detailStudent); }}>
                Assign Test Now
              </button>
            )}
          </Modal.Footer>
        </Modal>

      </Container>
    );
  }
}

export default withRouter(withApollo(RegisteredStudentsPage));
